import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="ReVoice" link="https://github.com/thetseffect/ReVoice" bg="linear-gradient(to right,rgba(232,203,192,0.5), rgba(99,111,164, 0.5))" mdxType="ProjectCard">
This project is a prototype version for Smart Review Anlysis using NLP and Computer Vision techniques.
    </ProjectCard>
    <ProjectCard title="Office-Desk" link="https://thawing-gorge-92211.herokuapp.com" bg="linear-gradient(to right,rgba(101,78,163, 0.5), rgba(234,175,200,0.5))" mdxType="ProjectCard">
This project was prepared as a part of Innovaccer's Summer Geeks Challenge 2020. An office helpdesk build on NodeJS.
    </ProjectCard>
    <ProjectCard title="Crypto Assist" link="https://assistant.google.com/services/a/uid/0000007451b2eca2?source=web" bg="linear-gradient(to right,rgba(58,28,113,0.4), rgba(215,109,119,0.4), rgba(255,175,123,0.4))" mdxType="ProjectCard">
This project is a Google Action, bringing the major Crypto needs to you by leveraging the power of #Voice.
    </ProjectCard>
    <ProjectCard title="React Chat App" link="https://sharp-cori-16305f.netlify.app/" bg="linear-gradient(to right,rgba(232,203,192,0.5), rgba(99,111,164, 0.5))" mdxType="ProjectCard">
A chat app (webapp) built using ReactJS, SocketIO and NodeJS.
    </ProjectCard>
    <ProjectCard title="Zubi.io Voice App" link="https://github.com/thetseffect/Zubi.io-Virtual-Assistant" bg="linear-gradient(to right,rgba(232,203,192,0.5), rgba(99,111,164, 0.5))" mdxType="ProjectCard">
A voice app for Zubi.io, which brings you daily feed on demand and even through push notifications.
    </ProjectCard>
    <ProjectCard title="More on Github" link="https://github.com/thetseffect" bg="linear-gradient(to right,rgba(214,109,117,0.7), rgba(226,149,135,0.6))" mdxType="ProjectCard">
🔗
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      